import { DateTime } from 'luxon';

export interface ScheduleWindow {
    openHour: string;
    closeHour: string;
}

export interface ScheduleHours {
    pickup: string[];
    return: string[];
}

export interface ScheduleHourAvailability {
    isAvailable: boolean;
    scheduleWindow: ScheduleWindow | null;
}

export function resolveReturnBranchId(
    showDifferentLocation: boolean,
    currentLocation: string[] | null | undefined,
    currentDifferentLocation: string[] | null | undefined,
): string {
    return (
        showDifferentLocation
            ? currentDifferentLocation?.[0]
            : currentLocation?.[0]
    ) as string;
}

export function getScheduleHours(schedulesResponse: unknown): ScheduleHours {
    const schedules = (
        schedulesResponse as {
            data?: {
                schedules?: {
                    pickup?: string[];
                    return?: string[];
                };
            };
        }
    )?.data?.schedules;

    return {
        pickup: schedules?.pickup ?? [],
        return: schedules?.return ?? [],
    };
}

export function getScheduleWindow(hours: string[]): ScheduleWindow | null {
    if (hours.length === 0) {
        return null;
    }

    return {
        openHour: formatScheduleHour(hours[0]),
        closeHour: formatScheduleHour(hours[hours.length - 1]),
    };
}

export function formatScheduleHour(hour: string): string {
    const normalizedHour = hour.length === 5 ? `${hour}:00` : hour;
    const formattedHour = DateTime.fromFormat(normalizedHour, 'HH:mm:ss');

    if (!formattedHour.isValid) {
        return hour;
    }

    return formattedHour.toFormat('h:mm a').toUpperCase();
}

export function validateScheduleHourAvailability(
    hour: string | null | undefined,
    availableHours: string[],
): ScheduleHourAvailability {
    return {
        isAvailable: typeof hour === 'string' && availableHours.includes(hour),
        scheduleWindow: getScheduleWindow(availableHours),
    };
}

export function resolveAutoHour(
    hours: string[],
    date: Date,
    selectedHour?: string | null,
): string | null {
    if (!hours || hours.length === 0) return null;
    if (selectedHour && hours.includes(selectedHour)) return selectedHour;

    const now = DateTime.now();
    const selected = DateTime.fromJSDate(date).startOf('day');
    const isToday = selected.hasSame(now.startOf('day'), 'day');

    if (isToday) {
        return hours[0] ?? null;
    } else {
        return hours.find((h) => h === 'Mediodía') ?? null;
    }
}
